module.exports = __webpack_public_path__ + "img/voucher-blue.873915ed.png";